module.exports = __webpack_public_path__ + "img/AL804-2-EN.f5d4b5b7.jpg";